<!-- rodapé -->
<div class="footer">
  
  

  <div class="logotipos" style="margin: 0px; padding: 0px">
    <div
      style="display: flex; flex-direction: row; flex-wrap: wrap; box-sizing: border-box; max-width: 100%; justify-content: space-between; align-items: flex-start; flex: 1 1 100%;"
    >
      <ngu-carousel [inputs]="carouselTile" [dataSource]="carouselTileItems" style="width: 100%">
        <ngu-tile *nguCarouselDef="let item; let i = index">
          <!-- <a [href]="carouselTileItems[i].URL" target="_blank"> -->
          <img
            [src]="carouselTileItems[i].logo"
            [alt]="carouselTileItems[i].alt"
            loading="lazy"
            class="img-footer"
            width="120"
            height="60"
          />
          <!-- </a> -->
        </ngu-tile>
      </ngu-carousel>
    </div>
  </div>

  <div class="footer-toolbar-copyright">
    <div style="display: flex; flex-direction: row; flex-wrap: wrap; box-sizing: border-box; max-width: 100%; justify-content: space-between; align-items: flex-start; flex: 1 1 100%;">
      
      <!-- Coluna 1: Contactos -->
      <div 
        class="contact-column"
      >
        <h3 class="contact-title">Contactos</h3>
        <p class="contact-item">
          <mat-icon class="contact-icon" aria-hidden="true">email</mat-icon>
          <a href="mailto:geral@segurosvirtual.pt" aria-label="Enviar email para geral@segurosvirtual.pt">geral@segurosvirtual.pt</a>
        </p>
      </div>

      <!-- Coluna 2: Apoio Comercial -->
      <div 
        class="contact-column"
      >
        <h3 class="contact-title">Apoio Comercial</h3>
        <p class="contact-item">
          <mat-icon class="contact-icon" aria-hidden="true">email</mat-icon>
          <a href="mailto:comercial@segurosvirtual.pt" aria-label="Enviar email para o departamento comercial">comercial@segurosvirtual.pt</a>
        </p>
        <p class="contact-item">
          <mat-icon class="contact-icon" aria-hidden="true">phone</mat-icon>
          <a href="tel:+351915841608" aria-label="Ligar para o apoio comercial">+351 915 841 608</a>
        </p>
      </div>

      <!-- Coluna 3: Apoio Reclamações -->
      <div 
        class="contact-column"
      >
        <h3 class="contact-title">Apoio Reclamações</h3>
        <p class="contact-item">
          <mat-icon class="contact-icon" aria-hidden="true">email</mat-icon>
          <a href="mailto:reclamacoes@segurosvirtual.pt" aria-label="Enviar reclamação por email">reclamacoes@segurosvirtual.pt</a>
        </p>
      </div>

      <!-- Coluna 4: Logotipo -->
      <div 
        class="logo-column"
      >
        <a routerLink="/home" class="footer-logo-link">
          <img src="assets/logotipos/LogoRodape.webp" alt="Logótipo Seguros Virtual" loading="lazy" class="footer-logo" width="180" height="54" />
        </a>
      </div>

      <!-- Coluna 5: Redes Sociais -->
      <div 
        class="social-column"
      >
        <h3 class="follow-title">Segue-nos</h3>
        <div class="social-icons-row">
          <a href="https://www.facebook.com/segurosvirtual.pt" target="_blank" rel="noopener" aria-label="Visitar a nossa página no Facebook">
            <img src="assets/logotipos/Facebook.png" alt="Facebook" loading="lazy" width="32" height="32" />
          </a>
          <a href="https://www.instagram.com/segurosvirtual_pt/" target="_blank" rel="noopener" aria-label="Visitar o nosso Instagram">
            <img src="assets/logotipos/Instagram.png" alt="Instagram" loading="lazy" width="32" height="32" />
          </a>
          <a href="https://pt.linkedin.com/company/segurosvirtualpt" target="_blank" rel="noopener" aria-label="Visitar o nosso perfil no LinkedIn">
            <img src="assets/logotipos/LinkedIn.png" alt="LinkedIn" loading="lazy" width="32" height="32" />
          </a>
          <a href="https://wa.me/351911179153" target="_blank" rel="noopener" aria-label="Falar connosco pelo WhatsApp">
            <img src="assets/logotipos/Whatsup.png" alt="WhatsApp" loading="lazy" width="32" height="32" />
          </a>
        </div>
      </div>


      <!-- Nova linha para imagem PESSOAS2030 -->
      <div style="display: flex; flex-direction: column; align-items: center; margin-top: 25px; padding-top: 25px; padding-bottom: 15px; width: 100%; border-top: 1px solid rgba(255,255,255,0.2);">
        <span class="force-white" style="margin-bottom: 10px; font-weight: bold; text-align: center;">Região NUT II – Norte, Centro e Alentejo:</span>
        <picture>
          <source srcset="assets/footer/PESSOAS2030mobile.webp?v=2" media="(max-width: 599px)">
          <img src="assets/footer/PESSOAS2030.webp?v=2" alt="PESSOAS 2030" loading="lazy" class="footer-nut-img" />
        </picture>
      </div>

      <!-- Barra inferior com links -->
      <!-- Barra inferior com links Reestruturada -->
      <div class="footer-bottom-container">
        <!-- Desktop: Linha única com espaçamento igual -->
        <!-- Mobile: Coluna (um por linha) via SCSS media query -->
        <ul class="footer-links-list">
          <li>
            <span class="force-white">©2026 Seguros Virtual - Todos os Direitos Reservados</span>
          </li>
          <li>
            <button class="footer-link-action-btn" (click)="baseService.openDialogPrivacity(1)" type="button">
              Política de Privacidade
            </button>
          </li>
          <li>
            <button class="footer-link-action-btn" (click)="baseService.openDialogPrivacity(3)" type="button">
              Condições de Utilização
            </button>
          </li>
          <li>
            <a href="https://www.livroreclamacoes.pt/inicio" target="_blank" rel="noopener">
              Livro de Reclamações
            </a>
          </li>
          <li>
            <span class="cert-badge force-white"><i class="fa fa-lock" aria-hidden="true"></i> SSL Seguro</span>
          </li>
          <li>
            <span class="cert-badge force-white"><i class="fa fa-check" aria-hidden="true"></i> RGPD Conforme</span>
          </li>

          <li>
            <button class="footer-link-action-btn" (click)="openCookieSettings()" type="button">
              Cookies
            </button>
          </li>
        </ul>
      </div>


    </div>
  </div>
</div>
